var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChalmersLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258.857,
    height: 89.726,
    viewBox: "0 0 258.857 89.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13560",
    "data-name": "Group 13560",
    transform: "translate(7550.321 -11157.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4057",
    "data-name": "Path 4057",
    d: "M180.151,130.873c.571-2.694-.2-7.292-.2-7.292l-.984,1a19.245,19.245,0,0,0-1.357,1.7l.073.533a15.038,15.038,0,0,1,2.028-2.468,29.107,29.107,0,0,1,.22,4.647,14.219,14.219,0,0,1-.268,2Z",
    transform: "translate(-7648.657 11084.384)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4058",
    "data-name": "Path 4058",
    d: "M169.006,133.954a13.347,13.347,0,0,0-1.175,3.845,10.858,10.858,0,0,0,.286,3.509,6.678,6.678,0,0,1,.157,2.486l.494-.237a13.228,13.228,0,0,0-.225-2.284,13.772,13.772,0,0,1-.359-2.551,7.056,7.056,0,0,1,.056-.9,9.3,9.3,0,0,1,.7-2.667Z",
    transform: "translate(-7644.803 11080.371)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4059",
    "data-name": "Path 4059",
    d: "M180.323,134.584a12.607,12.607,0,0,0-7.138,2.633c-2.386,1.963-3.409,5.524-3.661,6.759l-.024.573a14.443,14.443,0,0,1,2.7-1.252,10.761,10.761,0,0,0,2.874-1.492,21.633,21.633,0,0,0,5.38-7.013l.109-.214Zm-7.136,3.109a12.271,12.271,0,0,1,6.72-2.719,19.872,19.872,0,0,1-5.02,6.444,10.47,10.47,0,0,1-2.794,1.456,13.38,13.38,0,0,0-2.254,1.05c.336-1.328,1.166-4.326,3.348-6.232",
    transform: "translate(-7645.401 11080.129)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4060",
    "data-name": "Path 4060",
    d: "M115.017,181.045a15.136,15.136,0,0,0-2.035,3.372,4.7,4.7,0,0,1,.143-1.422,3.148,3.148,0,0,0-1.438.767,7.974,7.974,0,0,1,2.353-2.832l-.1-.124a6.4,6.4,0,0,0-1.419,1.2,3.99,3.99,0,0,0-1.3,2.184s-.024.6.286.141a2.775,2.775,0,0,1,1.236-.868,7.5,7.5,0,0,0-.036,1.19s.043.86.285.312a12.744,12.744,0,0,1,2.534-4.022Z",
    transform: "translate(-7623.584 11061.896)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4061",
    "data-name": "Path 4061",
    d: "M128.642,180.168h0Z",
    transform: "translate(-7630.704 11062.156)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4062",
    "data-name": "Path 4062",
    d: "M114.257,180.635a8.212,8.212,0,0,1,2.055,4l.087.4s.351-1.609.385-2.1c.257.239,1.539,1.363,1.539,1.363a5.557,5.557,0,0,0-2.965-4.265l-.112.275a4.226,4.226,0,0,1,1.658,1.338,4.861,4.861,0,0,1,.851,1.8,3.54,3.54,0,0,0-1.237-.981,13.869,13.869,0,0,1-.154,1.5,6.285,6.285,0,0,0-.826-2.1,6.13,6.13,0,0,0-.961-1.305Zm1.484-1.289c.611.22,4.812,1.5,4.87,1.705s-.61.3-.9.2a11.942,11.942,0,0,0-4.043-1.714l-.032.188a10.479,10.479,0,0,1,3.782,1.817.607.607,0,0,0,.3.122c.4.008.834-.3,1.074-.319s.36-.563,0-.586-4.317-1.494-5.046-1.64Zm-4.235.283a16.618,16.618,0,0,0-4.1,1.748c-.283.109-.709-.1-.657-.3s3.918-1.35,4.671-1.632v-.222c-.874.212-4.558,1.53-4.918,1.564s-.153.6,0,.667a1.891,1.891,0,0,0,.906.3,1,1,0,0,0,.372-.149,11.124,11.124,0,0,1,3.851-1.813Z",
    transform: "translate(-7621.571 11062.584)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4063",
    "data-name": "Path 4063",
    d: "M118.69,177.9a1.345,1.345,0,0,1,1.633.228c.149.279.109.481-.043.88a1.174,1.174,0,0,1-1.02.649,1.49,1.49,0,0,1-.806-.23l-.191.151a1.221,1.221,0,0,0,.906.427,1.443,1.443,0,0,0,1.439-.9,1.469,1.469,0,0,0,.019-1.1,1.055,1.055,0,0,0-.585-.5,1.93,1.93,0,0,0-1.037-.063,1.563,1.563,0,0,0-.512.241Zm-.253.539h0Z",
    transform: "translate(-7626.461 11063.287)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4064",
    "data-name": "Path 4064",
    d: "M114.69,177.82a1.541,1.541,0,0,0,.216,1.278,1.17,1.17,0,0,0,.827.545c.5.054,1.266.236,1.642-.615.287-.925-.018-1.606-.742-1.743-.81-.155-1.741.029-1.942.536m1.847-.321c.689.115.575.915.471,1.369-.122.531-.525.5-1.21.43a.989.989,0,0,1-.628-.4,1.307,1.307,0,0,1-.284-.7.917.917,0,0,1,.046-.29,1.282,1.282,0,0,1,1.607-.413",
    transform: "translate(-7624.975 11063.358)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4065",
    "data-name": "Path 4065",
    d: "M175.668,141.462a10.222,10.222,0,0,0-4.181,3.886c-.039.06-.032.2.014.148a17.1,17.1,0,0,1,4.3-3.885c.63-.308.309-.336-.132-.148",
    transform: "translate(-7646.224 11077.36)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4066",
    "data-name": "Path 4066",
    d: "M182.113,102.8a13.177,13.177,0,0,0-3.125-5.359l-.171-.245-.052.293-.3,1.05a17.019,17.019,0,0,0-1,5.556l.453.223c-.255-1.681.69-4.821,1.111-6.264a11.524,11.524,0,0,1,2.674,5.005Z",
    transform: "translate(-7648.581 11094.718)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4067",
    "data-name": "Path 4067",
    d: "M178.1,109.769c-.818-1.758-4.492-4.511-4.492-4.511a47.5,47.5,0,0,0,.439,5.273l.475.209a40.864,40.864,0,0,1-.525-4.668c.206.163,3.034,2.388,3.825,4.087Zm-.387,6.97a8.806,8.806,0,0,0-1.4-2.044l-.043.5a9.72,9.72,0,0,1,1.262,1.838Z",
    transform: "translate(-7647.068 11091.626)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4068",
    "data-name": "Path 4068",
    d: "M185.981,102.525a12.636,12.636,0,0,0-5.3,5.533,12.8,12.8,0,0,0-.338,7.618l.419-.42.145.931a13.188,13.188,0,0,1,1.791-2.28,10.863,10.863,0,0,0,1.861-2.65c1.428-2.924,1.548-6.308,1.63-8.6l.008-.246Zm-5.368,12.826a16.357,16.357,0,0,1-.267-3.156,11.374,11.374,0,0,1,.733-4.022,13.762,13.762,0,0,1,4.727-5.135,18.089,18.089,0,0,1-1.745,8.092,12.188,12.188,0,0,1-1.86,2.586,10.571,10.571,0,0,0-1.329,1.768c-.02-.089-.238-.023-.258-.132",
    transform: "translate(-7649.533 11092.768)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4069",
    "data-name": "Path 4069",
    d: "M181,120.021c-.007.07.126-.2.2-.2s.112.372.118.3a12.534,12.534,0,0,1,1.98-6.132c.033-.061.01-.216-.047-.174a12,12,0,0,0-2.248,6.2",
    transform: "translate(-7649.991 11088.194)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4070",
    "data-name": "Path 4070",
    d: "M178.6,132.551a11.4,11.4,0,0,1-.682,1.47c-.024.066,0,.521.027.453l.693-1.651c.08-.245.28-1.113-.039-.272",
    transform: "translate(-7648.788 11080.919)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4071",
    "data-name": "Path 4071",
    d: "M176.478,112.035a14.2,14.2,0,0,1,2.063,4.422c.018.069.085-.39.063-.456-.5-1.567-1.265-3.428-2.041-4.024-.174-.133-.189-.057-.085.059",
    transform: "translate(-7648.19 11088.916)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    "data-name": "Path 4072",
    d: "M181.262,108.987a17.422,17.422,0,0,0-.383-3.792c.009-.205.066-.1.084-.037a10.846,10.846,0,0,1,.4,3.738Z",
    transform: "translate(-7649.959 11091.588)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    "data-name": "Path 4073",
    d: "M171.365,142.552a11.257,11.257,0,0,0,.367-3.691c.253-.025.63,1.413.018,3.287Z",
    transform: "translate(-7646.217 11078.324)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    "data-name": "Path 4074",
    d: "M163.42,155.714a14.461,14.461,0,0,0,2.26-6.012,36.975,36.975,0,0,0-6.126,2.976l.064.407c.622-.692,5.381-2.6,5.659-2.706a14.239,14.239,0,0,1-2.327,5.271Z",
    transform: "translate(-7641.535 11074.12)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    "data-name": "Path 4075",
    d: "M148,160.185a9.783,9.783,0,0,0,1.017-2.423,9.666,9.666,0,0,1,1.162-2.952c.654-1.406,4.159-4.224,4.335-4.364a15.544,15.544,0,0,1-.929,5.562l.384-.037a10.787,10.787,0,0,0,.871-5.087l.059-1.211-.823.643a18.246,18.246,0,0,0-4.2,4.165,11.153,11.153,0,0,0-1.276,3.212,7.567,7.567,0,0,1-1.064,2.523Z",
    transform: "translate(-7636.806 11074.624)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4076",
    "data-name": "Path 4076",
    d: "M162.513,160.549a12.643,12.643,0,0,0-7.6-.939,12.509,12.509,0,0,0-6.372,4.481h.361l-.281.56a12.319,12.319,0,0,1,2.809.074,10.784,10.784,0,0,0,3.238-.094c3.2-.6,5.981-2.531,7.865-3.833l.2-.14Zm-11.172,1.28a10.1,10.1,0,0,1,3.678-1.894c2.976-.627,5.238.319,6.916.771-1.862,1.274-4.158,3-7.417,3.519a12.264,12.264,0,0,1-3.16.089c-.808-.067-1.59-.125-2.452-.145a13.964,13.964,0,0,1,2.433-2.339",
    transform: "translate(-7637.152 11070.66)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4077",
    "data-name": "Path 4077",
    d: "M151.285,164.693c-.063.033-.309.3-.272.364s.373-.018.436-.051A16.629,16.629,0,0,1,157,163.05c.07-.015.181-.122.112-.143-.5-.155-3.1.369-5.827,1.786",
    transform: "translate(-7638.178 11069.225)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4078",
    "data-name": "Path 4078",
    d: "M154.784,156.035a48.5,48.5,0,0,0-2.313,4.3c-.032.064.46-.153.481-.22a19,19,0,0,1,2.1-4.084c.135-.173-.177-.122-.265.007",
    transform: "translate(-7638.776 11071.646)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4079",
    "data-name": "Path 4079",
    d: "M159.64,157.584a18.5,18.5,0,0,0,3.488-3.252,8.771,8.771,0,0,1-3.173,3.258Z",
    transform: "translate(-7641.588 11072.243)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4080",
    "data-name": "Path 4080",
    d: "M140.927,172a16.327,16.327,0,0,0,3.821-4.813l.17-.248-.292.055-1.088.086a17.368,17.368,0,0,0-5.356.922l-.074.438a25.6,25.6,0,0,1,6.036-1.041,15.309,15.309,0,0,1-3.754,4.412Z",
    transform: "translate(-7633.107 11067.563)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    d: "M123.727,171.779a12.936,12.936,0,0,0,1.316-1.851,12,12,0,0,1,2.088-2.9,22.7,22.7,0,0,1,5.473-2.723c-.08.248-1.329,4.157-2.723,5.22l.41.113a12.351,12.351,0,0,0,2.544-4.855l.4-1.144-1.007.438a18.559,18.559,0,0,0-5.4,2.677,12.735,12.735,0,0,0-2.168,3.033,16.917,16.917,0,0,1-1.79,2.412Z",
    transform: "translate(-7627.102 11068.912)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4082",
    "data-name": "Path 4082",
    d: "M137.346,176.292a13.081,13.081,0,0,0-6.867-2.824c-3.153-.152-7.393,2.238-8.418,2.975l.006.307.441-.054c1.25.229,2.2.5,3.058.733a16.8,16.8,0,0,0,3.271.791c3.24.316,6.451-.754,8.625-1.478l.411-.12Zm-10.914-1.676a10.009,10.009,0,0,1,4.032-.771c2.9.2,4.617,1.451,6.444,2.659-2.622.708-4.393,1.571-8.07,1.312a14.544,14.544,0,0,1-3.232-.791c-.787-.225-1.764-.407-2.852-.634a22.628,22.628,0,0,1,3.677-1.775",
    transform: "translate(-7626.758 11064.898)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4083",
    "data-name": "Path 4083",
    d: "M133.2,177.288c.07.012.385.2.366.267s-.362.091-.433.08a16.641,16.641,0,0,0-5.88-.247c-.07.006-.207-.063-.15-.1.438-.3,3.078-.556,6.1,0",
    transform: "translate(-7628.783 11063.469)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4084",
    "data-name": "Path 4084",
    d: "M131.868,169.509a26.907,26.907,0,0,1-3.151,3.116c-.048.051.485-.017.524-.078.488-.748,2.559-2.434,3.157-3.331.121-.184-.442.166-.53.293",
    transform: "translate(-7629.434 11066.656)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    d: "M137.419,172.344a14.177,14.177,0,0,1,3.645-2.045c.414-.229-.365,0-.664.1a9.64,9.64,0,0,0-3.327,1.921Z",
    transform: "translate(-7632.717 11066.231)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4086",
    "data-name": "Path 4086",
    d: "M56.084,130.83a12.807,12.807,0,0,1-.17-1.922,28.592,28.592,0,0,1,.133-4.561c.322.294.73.7,1.565,1.6l-.025-.582a9.341,9.341,0,0,1-.8-.786l-.984-1s-.724,4.53-.153,7.226Z",
    transform: "translate(-7600.773 11084.382)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4087",
    "data-name": "Path 4087",
    d: "M66.486,131.293c-.234-.293,1.358,2.994,1.61,5.143a7.29,7.29,0,0,1,.055.9,13.674,13.674,0,0,1-.361,2.551,14.324,14.324,0,0,0-.251,2.355l.435.167a10.4,10.4,0,0,1,.208-2.463,11.336,11.336,0,0,0,.34-3.587,25.216,25.216,0,0,0-1.977-5.8Z",
    transform: "translate(-7605.282 11081.739)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4088",
    "data-name": "Path 4088",
    d: "M56.679,137.457c2.175,1.789,3.133,5.185,3.47,6.514a13.369,13.369,0,0,0-2.256-1.052,11.418,11.418,0,0,1-2.836-1.584,17.425,17.425,0,0,1-5.02-6.4,14.284,14.284,0,0,1,4.8,1.221l.041-.421a13.528,13.528,0,0,0-5.215-1.147l-.241-.005.109.214a21.619,21.619,0,0,0,5.379,7.012,10.774,10.774,0,0,0,2.872,1.492,13.534,13.534,0,0,1,2.66,1.191l.018-.513c-.246-1.205-1.121-4.707-3.393-6.7Z",
    transform: "translate(-7598.315 11080.128)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4089",
    "data-name": "Path 4089",
    d: "M58.726,141.462a10.21,10.21,0,0,1,4.18,3.886c.04.06.033.2-.014.148a17.085,17.085,0,0,0-4.3-3.885c-.631-.308-.31-.336.131-.148",
    transform: "translate(-7601.921 11077.36)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4090",
    "data-name": "Path 4090",
    d: "M52.793,102.949a14.473,14.473,0,0,1,2.671-4.942c.851,2.787,1.318,5.431,1.136,6.344l.456-.345a16.471,16.471,0,0,0-1.069-5.472l-.3-1.05-.051-.293-.172.245a15.406,15.406,0,0,0-3.082,5.271Z",
    transform: "translate(-7599.526 11094.719)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4091",
    "data-name": "Path 4091",
    d: "M56.71,110.073c.79-1.7,3.663-3.882,3.868-4.045-.007.226-.049,2.7-.235,4.156l.446-.157a30.569,30.569,0,0,0,.135-4.77s-3.675,2.754-4.493,4.512Zm.339,7.092a5.081,5.081,0,0,1,.763-1.188l-.06-.579a4.652,4.652,0,0,0-.935,1.427Z",
    transform: "translate(-7601.181 11091.627)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4092",
    "data-name": "Path 4092",
    d: "M47.058,102.413a17.78,17.78,0,0,0,1.638,8.843,10.81,10.81,0,0,0,1.906,2.585,12.044,12.044,0,0,1,1.778,2.185l.112-.771.419.42a13.539,13.539,0,0,0-.337-7.618c-1.429-3.615-5.517-5.645-5.517-5.645m5.329,13.157a11.7,11.7,0,0,0-1.329-1.854,9.309,9.309,0,0,1-1.94-2.574,17.121,17.121,0,0,1-1.707-8.147,9.7,9.7,0,0,1,5.459,9.2,16.48,16.48,0,0,1-.223,3.114c-.021.109-.239.173-.26.261",
    transform: "translate(-7597.328 11092.766)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4093",
    "data-name": "Path 4093",
    d: "M55.043,120.021c.005.07-.127-.2-.2-.2s-.112.372-.119.3a11.477,11.477,0,0,0-1.979-6.132c-.035-.06-.01-.216.047-.174a12.007,12.007,0,0,1,2.248,6.2",
    transform: "translate(-7599.668 11088.194)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4094",
    "data-name": "Path 4094",
    d: "M59.643,112.038a11.359,11.359,0,0,0-2.061,4.422,1.391,1.391,0,0,1-.063-.456c.369-1.526,1.29-3.489,2.04-4.024.179-.128.2-.05.085.059",
    transform: "translate(-7601.624 11088.913)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4095",
    "data-name": "Path 4095",
    d: "M56.041,108.987a17.338,17.338,0,0,1,.384-3.792c-.009-.205-.067-.1-.084-.037a10.8,10.8,0,0,0-.4,3.738Z",
    transform: "translate(-7600.98 11091.588)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4096",
    "data-name": "Path 4096",
    d: "M65.794,142.451a25.48,25.48,0,0,1-.47-3.666c-.254-.028-.45,1.545.161,3.418Z",
    transform: "translate(-7604.717 11078.353)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4097",
    "data-name": "Path 4097",
    d: "M73.784,152.708a18.5,18.5,0,0,0-5-2.411l-1.022-.385-.264-.137.093.285a14.791,14.791,0,0,0,2.369,5.693l.486-.112a16.035,16.035,0,0,1-2.415-5.232c.278.1,5.037,2.057,5.659,2.75Z",
    transform: "translate(-7605.708 11074.091)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4098",
    "data-name": "Path 4098",
    d: "M84.541,160.185l.517.018A7.463,7.463,0,0,1,84,157.7a11.156,11.156,0,0,0-1.285-3.224,18.366,18.366,0,0,0-4.247-4.161l-.823-.643.059,1.211a10.8,10.8,0,0,0,.871,5.087l.384-.007c-.889-1.652-.922-5.257-.929-5.518a24.914,24.914,0,0,1,4.336,4.234,10.528,10.528,0,0,1,1.2,3.082,9.739,9.739,0,0,0,.974,2.423",
    transform: "translate(-7609.853 11074.624)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4099",
    "data-name": "Path 4099",
    d: "M65.234,160.657l.2.14c1.884,1.3,4.667,3.229,7.865,3.834a10.784,10.784,0,0,0,3.238.094,12.319,12.319,0,0,1,2.81-.074l-.281-.56h.361a12.5,12.5,0,0,0-6.371-4.481,12.644,12.644,0,0,0-7.6.939Zm13.7,3.511c-.861.021-1.513.079-2.321.145a12.673,12.673,0,0,1-3.159-.176,17.548,17.548,0,0,1-7.418-3.39,10.767,10.767,0,0,1,6.96-.685,11.136,11.136,0,0,1,3.636,1.765,12.181,12.181,0,0,1,2.3,2.339",
    transform: "translate(-7604.78 11070.66)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4100",
    "data-name": "Path 4100",
    d: "M82.117,164.693c.063.033.31.3.273.364s-.374-.018-.437-.051a16.624,16.624,0,0,0-5.55-1.956c-.07-.015-.18-.122-.112-.143.5-.155,3.105.369,5.827,1.786",
    transform: "translate(-7609.291 11069.225)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4101",
    "data-name": "Path 4101",
    d: "M81.195,156.035a48.764,48.764,0,0,1,2.313,4.3c.031.064-.461-.153-.482-.22a19.019,19.019,0,0,0-2.1-4.084c-.136-.173.177-.122.265.007",
    transform: "translate(-7611.183 11071.646)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4102",
    "data-name": "Path 4102",
    d: "M75.585,157.584a18.5,18.5,0,0,1-3.488-3.252,8.789,8.789,0,0,0,3.173,3.258Z",
    transform: "translate(-7607.586 11072.243)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4103",
    "data-name": "Path 4103",
    d: "M92.285,171.781a13.169,13.169,0,0,1-3.56-4.3c.3.023,4.768.262,6.043,1.007L94.762,168a13.975,13.975,0,0,0-5.388-.891l-1.088-.083-.293-.057.171.248a15.6,15.6,0,0,0,3.72,4.81Z",
    transform: "translate(-7614.085 11067.552)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4104",
    "data-name": "Path 4104",
    d: "M107.616,172.478l.215-.239a10.347,10.347,0,0,1-1.936-2.434,12.378,12.378,0,0,0-2.165-2.969c-1.6-1.544-6.513-3.17-6.513-3.17s1.295,4.412,2.946,6l.453-.115a15.447,15.447,0,0,1-2.815-5.217,21.933,21.933,0,0,1,5.392,2.676,13.176,13.176,0,0,1,2.262,2.937,12.611,12.611,0,0,0,2.162,2.533",
    transform: "translate(-7617.855 11068.902)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4105",
    "data-name": "Path 4105",
    d: "M88.824,176.649l.411.119c2.174.722,5.387,1.791,8.626,1.471a10.827,10.827,0,0,0,3.133-.821,17.378,17.378,0,0,1,3.251-.767l.1-.278-.313-.231c-1.026-.737-4.663-2.808-7.816-2.654a13.058,13.058,0,0,0-6.863,2.831Zm14.88-.357a17.614,17.614,0,0,0-2.666.677,17.95,17.95,0,0,1-3.152.8c-2.083.393-6-.533-8.141-1.234a12.8,12.8,0,0,1,6.484-2.579,10.669,10.669,0,0,1,4.034.724,20.269,20.269,0,0,1,3.44,1.617",
    transform: "translate(-7614.425 11064.891)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4106",
    "data-name": "Path 4106",
    d: "M99.95,177.305c-.07.014-.385.2-.365.267s.362.091.432.08a16.726,16.726,0,0,1,5.88-.253c.071.008.208-.063.15-.1-.439-.3-3.079-.554-6.1.008",
    transform: "translate(-7618.824 11063.463)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4107",
    "data-name": "Path 4107",
    d: "M103.2,169.53a27.027,27.027,0,0,0,3.155,3.112c.047.052-.485-.017-.524-.076-.489-.75-2.562-2.432-3.16-3.33-.122-.184.442.166.529.294",
    transform: "translate(-7620.077 11066.648)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4108",
    "data-name": "Path 4108",
    d: "M97.366,172.366a14.122,14.122,0,0,0-3.647-2.04c-.413-.231.365,0,.664.095a9.654,9.654,0,0,1,3.328,1.92Z",
    transform: "translate(-7616.377 11066.221)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4109",
    "data-name": "Path 4109",
    d: "M116.64,174.37c-.05-.1-.153-.269-.153-.269a2.063,2.063,0,0,0-1.726-.728,1.01,1.01,0,0,0-.832.559,1.922,1.922,0,0,0,.866,2.048l.164-.14a1.843,1.843,0,0,1-.8-1.8.817.817,0,0,1,.648-.423,1.493,1.493,0,0,1,.762.161.927.927,0,0,0-.777.445,1.386,1.386,0,0,0,.341,1.546l.288-.039a1.355,1.355,0,0,1-.371-1.38.581.581,0,0,1,.452-.321.857.857,0,0,1,.565.079,1.35,1.35,0,0,1,.376.433,1.153,1.153,0,0,1-.137,1.178l.224.183a1.512,1.512,0,0,0,.112-1.528",
    transform: "translate(-7624.657 11064.941)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4110",
    "data-name": "Path 4110",
    d: "M116.933,174.351c.546.457.347,1.279.233,1.651l.276.085a1.693,1.693,0,0,0-.43-1.821Z",
    transform: "translate(-7625.917 11064.57)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4111",
    "data-name": "Path 4111",
    d: "M119.752,174.871a1.263,1.263,0,0,1,1.662-.915.915.915,0,0,1,.593.614,2.129,2.129,0,0,1-1.022,2.023l-.18-.3a1.661,1.661,0,0,0,.941-1.563.7.7,0,0,0-.386-.582,1.026,1.026,0,0,0-.78.025.928.928,0,0,1,.688.576,1.755,1.755,0,0,1-.5,1.553l-.281-.077a1.836,1.836,0,0,0,.574-1.36.77.77,0,0,0-.394-.481.531.531,0,0,0-.307-.053.8.8,0,0,0-.354.6,3.007,3.007,0,0,0,.038,1.1l-.2-.011a2.561,2.561,0,0,1-.085-1.144",
    transform: "translate(-7627.059 11064.728)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4112",
    "data-name": "Path 4112",
    d: "M119.7,174.332a2.387,2.387,0,0,0-1.051,1.966l-.24-.113a2.485,2.485,0,0,1,1.572-2.134Z",
    transform: "translate(-7626.519 11064.657)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4113",
    "data-name": "Path 4113",
    d: "M125.254,83.377c.255-.227.433-.387.433-.387l-1.677-2.849s-2.337,1-2.634,1.131c-.18-.241-1.1-1.523-1.266-1.751l1.554-2.429-2.347-2.335-2.325,1.778c-.229-.184-1.445-1.145-1.664-1.321l.933-2.834-.311-.205-.332.382c-.114.344-.914,2.776-.914,2.776l2.281,1.829,2.29-1.75c.232.231,1.48,1.481,1.71,1.712-.193.3-1.523,2.38-1.523,2.38l1.756,2.378,2.6-1.113c.169.288,1.078,1.833,1.249,2.12l-.506.451Zm-1.1,4.165s2.4-.346,2.744-.4c.1.322.628,2.082.724,2.4L125.1,90.9l.313,1.685.618.144c-.106-.572-.259-1.333-.3-1.537.281-.151,2.464-1.334,2.464-1.334l-.968-3.267-2.485.358Zm-5.842,28.514c.287-.275.475-.447.563-.529l2.4,1.4,2.1-2.559s-1.491-1.971-1.681-2.213c.141-.243.885-1.584,1.039-1.849.312.1.271.087,2.681.832l1.491-3.1s-1.973-1.532-2.222-1.722c.088-.276.572-1.788.659-2.06a1.218,1.218,0,0,1,.318-.056l-.773-.5-.879,2.749,2.288,1.748c-.14.3-.912,1.959-1.055,2.265l-2.751-.877L121,112.139l1.75,2.22c-.207.253-1.308,1.6-1.511,1.848l-2.441-1.431-.687.655Zm-32.892,4.829.353.272s1.823-1.727,2.045-1.94c.242.133,1.52.836,1.768.974-.058.318-.489,2.9-.489,2.9l2.991,1.251s1.28-2.137,1.446-2.418c.28.081,1.763.484,2.035.563.01.326.106,2.91.106,2.91l3.253.458s.787-2.441.881-2.748h2.1c.086.318.748,2.745.748,2.745l3.254-.369s.164-2.57.18-2.9c.286-.065,1.769-.421,2.037-.482.158.267,1.452,2.429,1.452,2.429l2.986-1.25s-.335-2.429-.385-2.741c.242-.136,1.515-.836,1.765-.973.222.23,1.936,1.934,1.936,1.934l1.116-.814-.239-.437c-.368.267-.706.516-.821.6l-1.984-2.067-2.463,1.377s.4,2.516.458,2.862c-.287.118-1.872.768-2.17.889l-1.445-2.455-2.807.64s-.134,2.578-.153,2.944l-2.365.273-.763-2.785h-2.9l-.838,2.779c-.319-.045-2.047-.3-2.366-.342l-.076-2.937-2.807-.824-1.451,2.468-2.167-.889c.064-.351.534-2.941.534-2.941l-2.46-1.375-2.054,1.984ZM78.8,83.481l-1.267-1.222c.18-.282,1.142-1.785,1.316-2.056l2.6,1.114,1.843-2.287-1.526-2.463,1.706-1.641c.277.211,2.291,1.75,2.291,1.75l1.752-1.334-.263-.421-1.489,1.134-2.326-1.778-2.294,2.208,1.552,2.506L81.3,80.714c-.286-.124-2.635-1.131-2.635-1.131L76.9,82.336l1.164,1.124Zm-1.762,2.726L75.2,85.95l-.972,3.038,2.479,1.453c-.034.163-.158.753-.27,1.288l.518-.129.3-1.414-2.444-1.433c.1-.309.621-1.942.72-2.252.2.028,1.091.153,1.821.257Zm-1.787,17.342h1.563c.087.273.57,1.78.659,2.058l-2.4,1.778,1.323,2.941,2.789-.727c.147.252.981,1.682,1.126,1.932l-1.862,2.261,1.993,2.629s2.291-1.3,2.563-1.456c.073.071.21.2.434.429l.153-.541-.562-.559-2.514,1.429c-.2-.265-1.251-1.66-1.445-1.916.222-.271,1.831-2.226,1.831-2.226l-1.49-2.559-2.75.716c-.132-.3-.849-1.889-.984-2.189l2.366-1.749-.881-2.753h-.9Zm38.4-32.688-.184-.1s-1.579,2-1.781,2.258c-.265-.12-1.673-.761-1.927-.875.025-.315.233-2.919.233-2.919l-3.135-.844s-.15.323-.347.743l.186.752c.2-.432.374-.8.423-.909.3.083,1.993.535,2.3.62-.029.361-.228,2.853-.228,2.853l2.632,1.188ZM95.11,68.386l-2.144.574s.139,2.675.155,2.992l-1.974.822c-.193-.273-1.705-2.423-1.705-2.423l-2.347,1.3.28.411L89.3,71c.211.3,1.679,2.386,1.679,2.386l2.641-1.1s-.134-2.585-.153-2.94L95,68.934Z",
    transform: "translate(-7608.459 11105.546)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4114",
    "data-name": "Path 4114",
    d: "M118.212,127.276c2.589,3,4.3,5.733,4.3,7.016a1.06,1.06,0,0,1-.046.325c-.65,1.96-4.859,4.293-8.845,4.22-3.473-.077-7.269-2.041-8.229-4.223a1.381,1.381,0,0,1-.08-.493c0-1.266,1.2-3.649,3.685-6.669l-.365-.451c-2.861,3.443-4.326,6.368-3.777,7.777,1.049,2.382,5.057,4.457,8.758,4.539,3.914.072,8.527-2.183,9.312-4.551.469-1.426-1.566-4.616-4.365-7.84ZM116,124.192c-.2-.2-.721-.709-.721-.709a4.21,4.21,0,0,1-1.731.352,3.025,3.025,0,0,1-1.586-.449s-.576.575-.789.794l.306.379c.184-.189.361-.326.553-.518a2.747,2.747,0,0,0,1.5.33,3.452,3.452,0,0,0,1.627-.268c.166.161.34.269.5.432Z",
    transform: "translate(-7620.93 11084.628)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4115",
    "data-name": "Path 4115",
    d: "M85.2,112.847c.842,2.4,2.3,4.438,3.8,4.977a2.184,2.184,0,0,0,1.189-.047l.121-.51a1.873,1.873,0,0,1-1.081.1c-1.259-.449-2.666-2.33-3.5-4.647Zm7.372,3.809a31.863,31.863,0,0,0,4.055-3.05l-.322-.364A33.864,33.864,0,0,1,92.687,116Zm-3.755-16.275a3.1,3.1,0,0,1,.361-.18c.59-.235,1.659.007,3.084.749l.675-.19c-1.71-.964-3.095-1.341-3.941-1a3.526,3.526,0,0,0-.531.277Z",
    transform: "translate(-7612.943 11093.922)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4116",
    "data-name": "Path 4116",
    d: "M138.408,100.8c1.785-1.211,3.214-1.836,3.9-1.6a2.757,2.757,0,0,1,.745.395l.324-.366a3.391,3.391,0,0,0-.914-.485c-.943-.326-2.679.482-4.688,1.9Zm-.464,14.047a25.864,25.864,0,0,1-2.809-2.114l-.3.372a26.134,26.134,0,0,0,3.277,2.4Zm7.4-1.913a6.846,6.846,0,0,1-3.054,3.434,2.955,2.955,0,0,1-2.016-.271l.1.537a3.094,3.094,0,0,0,2.1.178,7.376,7.376,0,0,0,3.306-3.7Z",
    transform: "translate(-7631.798 11094.298)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4117",
    "data-name": "Path 4117",
    d: "M119.148,79.2c-.236-.021-.473-.034-.708-.038a9.873,9.873,0,0,0-1.527.063l-.144.492a10.3,10.3,0,0,1,1.657-.074c.28.005.56.024.844.051Z",
    transform: "translate(-7625.85 11101.736)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4118",
    "data-name": "Path 4118",
    d: "M129.308,71.212a.144.144,0,0,0,0,.288h2.784a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7629.614 11104.856)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4119",
    "data-name": "Path 4119",
    d: "M106.346,71.212a.144.144,0,1,0,0,.288h1.288a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7621.53 11104.856)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4120",
    "data-name": "Path 4120",
    d: "M129.92,73.555a.145.145,0,0,0,0,.29H132.2a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7629.857 11103.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4121",
    "data-name": "Path 4121",
    d: "M106.473,73.555a.145.145,0,0,0,0,.29h.881a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7621.582 11103.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4122",
    "data-name": "Path 4122",
    d: "M96.389,73.555a.145.145,0,0,0,0,.29H99.1a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7617.459 11103.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4123",
    "data-name": "Path 4123",
    d: "M130.429,75.9a.144.144,0,1,0,0,.288h3.662a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7630.05 11103.015)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4124",
    "data-name": "Path 4124",
    d: "M118.278,75.9a.144.144,0,1,0,0,.288h.89a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7626.408 11103.015)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4125",
    "data-name": "Path 4125",
    d: "M97.667,75.9a.144.144,0,1,0,0,.288h5.694a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7617.981 11103.015)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4126",
    "data-name": "Path 4126",
    d: "M141.641,78.781a.145.145,0,0,0,0,.289H142.7a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7634.471 11101.881)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4127",
    "data-name": "Path 4127",
    d: "M131.044,78.238a.145.145,0,0,0,0,.29h3.36a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7630.293 11102.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4128",
    "data-name": "Path 4128",
    d: "M117.538,78.238a.145.145,0,1,0,0,.29h1.675a.145.145,0,1,0,0-.29Z",
    transform: "translate(-7626.105 11102.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4129",
    "data-name": "Path 4129",
    d: "M99.124,78.238a.145.145,0,0,0,0,.29h4.486a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7618.577 11102.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4130",
    "data-name": "Path 4130",
    d: "M147.692,81.125a.144.144,0,1,0,0,.288h2.54a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7636.841 11100.96)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4131",
    "data-name": "Path 4131",
    d: "M131.733,80.583a.143.143,0,0,0-.144.144.144.144,0,0,0,.144.144h2.056a.144.144,0,0,0,.143-.144.143.143,0,0,0-.143-.144Z",
    transform: "translate(-7630.571 11101.173)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4132",
    "data-name": "Path 4132",
    d: "M100.468,80.583a.143.143,0,0,0-.144.144.145.145,0,0,0,.144.144h3.36a.145.145,0,0,0,.144-.144.143.143,0,0,0-.144-.144Z",
    transform: "translate(-7619.126 11101.173)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4133",
    "data-name": "Path 4133",
    d: "M138.61,83.467a.145.145,0,0,0,0,.289h8.425a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7633.236 11100.039)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4134",
    "data-name": "Path 4134",
    d: "M88.071,83.467a.145.145,0,1,0,0,.289h6.854a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7614.058 11100.039)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4135",
    "data-name": "Path 4135",
    d: "M137.245,85.679a.145.145,0,1,0,0,.289h8.464a.145.145,0,1,0,0-.289Z",
    transform: "translate(-7632.699 11099.169)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4136",
    "data-name": "Path 4136",
    d: "M103.829,85.138a.144.144,0,0,0,0,.288h.729a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7620.501 11099.382)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4137",
    "data-name": "Path 4137",
    d: "M135.577,88.023a.144.144,0,1,0,0,.288h10.016a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7632.036 11098.247)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4138",
    "data-name": "Path 4138",
    d: "M86.938,88.023a.144.144,0,0,0,0,.288H95.93a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7613.595 11098.247)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4139",
    "data-name": "Path 4139",
    d: "M134.24,90.363a.145.145,0,1,0,0,.29h15.093a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7631.48 11097.328)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4140",
    "data-name": "Path 4140",
    d: "M79.648,90.363a.145.145,0,0,0,0,.29H93.556a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7610.614 11097.328)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4141",
    "data-name": "Path 4141",
    d: "M158.356,99.193a.144.144,0,0,0,0,.288h3.073a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7641.027 11093.857)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4142",
    "data-name": "Path 4142",
    d: "M75.836,99.193a.144.144,0,1,0,0,.288h2.871a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7609.056 11093.857)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4143",
    "data-name": "Path 4143",
    d: "M156.412,101.533a.145.145,0,0,0-.144.145.143.143,0,0,0,.144.143h4.719a.143.143,0,0,0,.144-.143.145.145,0,0,0-.144-.145Z",
    transform: "translate(-7640.252 11092.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4144",
    "data-name": "Path 4144",
    d: "M75.3,101.533a.145.145,0,0,0-.144.145.143.143,0,0,0,.144.143h4.524a.143.143,0,0,0,.145-.143.145.145,0,0,0-.145-.145Z",
    transform: "translate(-7608.836 11092.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4145",
    "data-name": "Path 4145",
    d: "M153.83,103.877a.144.144,0,1,0,0,.288h5.155a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7639.234 11092.015)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4146",
    "data-name": "Path 4146",
    d: "M79.148,103.877a.144.144,0,1,0,0,.288h3.639a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7610.41 11092.015)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4147",
    "data-name": "Path 4147",
    d: "M157.24,106.22a.144.144,0,0,0,0,.288h2.078a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7640.597 11091.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4148",
    "data-name": "Path 4148",
    d: "M115.045,120.145a.144.144,0,1,0,0,.288h5.39a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7625.086 11085.62)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4149",
    "data-name": "Path 4149",
    d: "M83.49,122.486a.145.145,0,1,0,0,.289h1.429a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7612.185 11084.699)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4150",
    "data-name": "Path 4150",
    d: "M151.61,124.827a.144.144,0,0,0,0,.288h3.561a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7638.374 11083.78)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4151",
    "data-name": "Path 4151",
    d: "M132.884,124.827a.144.144,0,0,0,0,.288h3.042a.144.144,0,0,0,0-.288Z",
    transform: "translate(-7631.018 11083.78)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4152",
    "data-name": "Path 4152",
    d: "M101.493,124.827a.144.144,0,1,0,0,.288h2.872a.144.144,0,0,0,0-.288Z",
    transform: "translate(-7619.545 11083.78)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4153",
    "data-name": "Path 4153",
    d: "M78.752,124.827a.144.144,0,1,0,0,.288h4.877a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7610.247 11083.78)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4154",
    "data-name": "Path 4154",
    d: "M149.7,127.173a.144.144,0,1,0,0,.288h5.938a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7637.608 11082.856)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4155",
    "data-name": "Path 4155",
    d: "M132.161,127.173a.144.144,0,1,0,0,.288H136.8a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7630.725 11082.856)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4156",
    "data-name": "Path 4156",
    d: "M98.274,127.173a.144.144,0,1,0,0,.288h3.909a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7618.229 11082.856)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4157",
    "data-name": "Path 4157",
    d: "M79.626,127.173a.144.144,0,1,0,0,.288h5.061a.144.144,0,0,0,0-.288Z",
    transform: "translate(-7610.605 11082.856)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4158",
    "data-name": "Path 4158",
    d: "M144.362,129.513a.144.144,0,0,0,0,.288H153a.144.144,0,0,0,0-.288Z",
    transform: "translate(-7635.493 11081.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4159",
    "data-name": "Path 4159",
    d: "M133.855,129.513a.144.144,0,1,0,0,.288h4.408a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7631.392 11081.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4160",
    "data-name": "Path 4160",
    d: "M128.026,129.513a.144.144,0,1,0,0,.288h1.442a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7630.393 11081.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4161",
    "data-name": "Path 4161",
    d: "M108.829,129.513a.144.144,0,0,0,0,.288h1.646a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7622.545 11081.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4162",
    "data-name": "Path 4162",
    d: "M97.148,129.513a.144.144,0,1,0,0,.288h3.8a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7617.769 11081.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4163",
    "data-name": "Path 4163",
    d: "M78.929,129.513a.144.144,0,1,0,0,.288H85.92a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7610.32 11081.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4164",
    "data-name": "Path 4164",
    d: "M144.972,131.857a.145.145,0,0,0,0,.289h9.671a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7635.726 11081.016)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4165",
    "data-name": "Path 4165",
    d: "M135.347,131.857a.145.145,0,1,0,0,.289h3.967a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7631.98 11081.016)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4166",
    "data-name": "Path 4166",
    d: "M129.925,131.857a.145.145,0,1,0,0,.289h1.2a.145.145,0,1,0,0-.289Z",
    transform: "translate(-7631.169 11081.016)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    "data-name": "Path 4167",
    d: "M107.262,131.857a.145.145,0,1,0,0,.289h1.465a.145.145,0,1,0,0-.289Z",
    transform: "translate(-7621.904 11081.016)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    "data-name": "Path 4168",
    d: "M113.386,122.5a.144.144,0,1,0,0,.287h6.97a.144.144,0,1,0,0-.287Z",
    transform: "translate(-7624.407 11084.691)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    "data-name": "Path 4169",
    d: "M96.43,131.857a.145.145,0,0,0,0,.289h3.326a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7617.476 11081.016)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    "data-name": "Path 4170",
    d: "M76.666,131.857a.145.145,0,0,0,0,.289h9.558a.145.145,0,1,0,0-.289Z",
    transform: "translate(-7609.395 11081.016)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    "data-name": "Path 4171",
    d: "M145.582,134.2a.145.145,0,0,0,0,.29h9.555a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7635.966 11080.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    "data-name": "Path 4172",
    d: "M136.905,134.2a.145.145,0,0,0,0,.29h3.446a.145.145,0,1,0,0-.29Z",
    transform: "translate(-7632.596 11080.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    "data-name": "Path 4173",
    d: "M131.483,134.2a.145.145,0,0,0,0,.29h1.2a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7630.477 11080.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    d: "M105.8,134.2a.145.145,0,1,0,0,.29h1.36a.145.145,0,1,0,0-.29Z",
    transform: "translate(-7621.305 11080.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    d: "M95.659,134.2a.145.145,0,0,0,0,.29h2.855a.145.145,0,1,0,0-.29Z",
    transform: "translate(-7617.16 11080.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    "data-name": "Path 4176",
    d: "M77.636,134.2a.145.145,0,0,0,0,.29h8.621a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7609.792 11080.095)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4177",
    "data-name": "Path 4177",
    d: "M146.259,136.54a.145.145,0,0,0-.144.145.143.143,0,0,0,.144.142h5.231a.143.143,0,0,0,.144-.142.145.145,0,0,0-.144-.145Z",
    transform: "translate(-7636.26 11079.175)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4178",
    "data-name": "Path 4178",
    d: "M138.329,136.54a.145.145,0,0,0-.144.145.143.143,0,0,0,.144.142h3.086a.143.143,0,0,0,.144-.142.145.145,0,0,0-.144-.145Z",
    transform: "translate(-7633.158 11079.175)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4179",
    "data-name": "Path 4179",
    d: "M133.11,136.54a.145.145,0,0,0-.145.145.143.143,0,0,0,.145.142h1.247a.143.143,0,0,0,.145-.142.145.145,0,0,0-.145-.145Z",
    transform: "translate(-7631.116 11079.175)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4180",
    "data-name": "Path 4180",
    d: "M104.28,136.54a.145.145,0,0,0-.144.145.143.143,0,0,0,.144.142h1.17a.143.143,0,0,0,.145-.142.145.145,0,0,0-.145-.145Z",
    transform: "translate(-7620.685 11079.175)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4181",
    "data-name": "Path 4181",
    d: "M94.838,136.54a.145.145,0,0,0-.145.145.143.143,0,0,0,.145.142h2.444a.144.144,0,0,0,.145-.142.146.146,0,0,0-.145-.145Z",
    transform: "translate(-7616.824 11079.175)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4182",
    "data-name": "Path 4182",
    d: "M84.129,136.54a.145.145,0,0,0-.145.145.143.143,0,0,0,.145.142h4.448a.143.143,0,0,0,.145-.142.145.145,0,0,0-.145-.145Z",
    transform: "translate(-7612.446 11079.175)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4183",
    "data-name": "Path 4183",
    d: "M146.87,138.884a.144.144,0,0,0,0,.288h4.115a.144.144,0,0,0,0-.288Z",
    transform: "translate(-7636.507 11078.253)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4184",
    "data-name": "Path 4184",
    d: "M139.955,138.884a.144.144,0,0,0,0,.288h2.565a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7633.8 11078.253)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4185",
    "data-name": "Path 4185",
    d: "M134.465,138.884a.144.144,0,1,0,0,.288h1.5a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7631.647 11078.253)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4186",
    "data-name": "Path 4186",
    d: "M102.764,138.884a.144.144,0,1,0,0,.288h1.7a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7620.064 11078.253)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4187",
    "data-name": "Path 4187",
    d: "M94.119,138.884a.144.144,0,0,0,0,.288h1.973a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7616.531 11078.253)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4188",
    "data-name": "Path 4188",
    d: "M84.526,138.884a.144.144,0,0,0,0,.288h3.819a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7612.608 11078.253)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4189",
    "data-name": "Path 4189",
    d: "M147.48,141.1a.144.144,0,0,0,0,.288h4.546a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7636.745 11077.384)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    "data-name": "Path 4190",
    d: "M141.447,141.1a.144.144,0,1,0,0,.288h2.123a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7634.388 11077.384)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4191",
    "data-name": "Path 4191",
    d: "M101.3,141.1a.144.144,0,1,0,0,.288h2.271a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7619.466 11077.384)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4192",
    "data-name": "Path 4192",
    d: "M93.4,141.1a.144.144,0,1,0,0,.288h1.562a.144.144,0,0,0,0-.288Z",
    transform: "translate(-7616.236 11077.384)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    d: "M82.757,141.1a.144.144,0,1,0,0,.288h4.531a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7611.885 11077.384)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    d: "M148.022,143.437a.145.145,0,0,0,0,.29h4.7a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7636.957 11076.463)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    d: "M143,143.437a.145.145,0,0,0,0,.29h1.643a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7635.003 11076.463)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    "data-name": "Path 4196",
    d: "M134.6,143.437a.145.145,0,0,0,0,.29h3.162a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7631.692 11076.463)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    "data-name": "Path 4197",
    d: "M99.782,143.437a.145.145,0,0,0,0,.29h3.662a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7618.846 11076.463)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4198",
    "data-name": "Path 4198",
    d: "M92.63,143.437a.145.145,0,0,0,0,.29h1.12a.145.145,0,1,0,0-.29Z",
    transform: "translate(-7615.922 11076.463)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4199",
    "data-name": "Path 4199",
    d: "M83.652,143.437a.145.145,0,0,0,0,.29H87.26a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7612.251 11076.463)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4200",
    "data-name": "Path 4200",
    d: "M144.632,145.78a.145.145,0,1,0,0,.289h1.042a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7635.646 11075.542)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4201",
    "data-name": "Path 4201",
    d: "M132.3,145.78a.145.145,0,1,0,0,.289h5.462a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7630.773 11075.542)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4202",
    "data-name": "Path 4202",
    d: "M98.266,145.78a.145.145,0,0,0,0,.289h5.956a.145.145,0,1,0,0-.289Z",
    transform: "translate(-7618.226 11075.542)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4203",
    "data-name": "Path 4203",
    d: "M91.774,145.78a.145.145,0,0,0,0,.289H92.5a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7615.572 11075.542)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4204",
    "data-name": "Path 4204",
    d: "M127.98,148.122a.144.144,0,1,0,0,.288h9a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7629.06 11074.621)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4205",
    "data-name": "Path 4205",
    d: "M96.7,148.122a.144.144,0,1,0,0,.288h9.332a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7617.585 11074.621)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4206",
    "data-name": "Path 4206",
    d: "M98.115,150.465a.145.145,0,1,0,0,.289h27.54a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7618.164 11073.7)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4207",
    "data-name": "Path 4207",
    d: "M143.841,152.808a.145.145,0,0,0-.144.145.143.143,0,0,0,.144.144h1.351a.143.143,0,0,0,.144-.144.145.145,0,0,0-.144-.145Z",
    transform: "translate(-7635.334 11072.78)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4208",
    "data-name": "Path 4208",
    d: "M100.48,152.808a.145.145,0,0,0-.145.145.143.143,0,0,0,.145.144h21.988a.143.143,0,0,0,.144-.144.144.144,0,0,0-.144-.145Z",
    transform: "translate(-7619.131 11072.78)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4209",
    "data-name": "Path 4209",
    d: "M131.863,155.149a.145.145,0,0,0,0,.29h3.667a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7630.614 11071.858)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4210",
    "data-name": "Path 4210",
    d: "M109.285,155.149a.145.145,0,0,0,0,.29H120.8a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7622.731 11071.858)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4211",
    "data-name": "Path 4211",
    d: "M100.226,155.149a.145.145,0,0,0,0,.29h3.3a.145.145,0,0,0,0-.29Z",
    transform: "translate(-7619.027 11071.858)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4212",
    "data-name": "Path 4212",
    d: "M133.3,157.493a.143.143,0,0,0-.144.144.145.145,0,0,0,.144.145h2.132a.145.145,0,0,0,.144-.145.143.143,0,0,0-.144-.144Z",
    transform: "translate(-7631.186 11070.938)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4213",
    "data-name": "Path 4213",
    d: "M121.511,157.493a.144.144,0,0,0-.145.144.145.145,0,0,0,.145.145h3.459a.145.145,0,0,0,.144-.145.143.143,0,0,0-.144-.144Z",
    transform: "translate(-7627.729 11070.938)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4214",
    "data-name": "Path 4214",
    d: "M110.726,157.493a.143.143,0,0,0-.144.144.145.145,0,0,0,.144.145h3.467a.146.146,0,0,0,.145-.145.144.144,0,0,0-.145-.144Z",
    transform: "translate(-7623.32 11070.938)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4215",
    "data-name": "Path 4215",
    d: "M102.2,157.493a.144.144,0,0,0-.145.144.145.145,0,0,0,.145.145h1.413a.145.145,0,0,0,.144-.145.143.143,0,0,0-.144-.144Z",
    transform: "translate(-7619.835 11070.938)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4216",
    "data-name": "Path 4216",
    d: "M122.18,159.834a.145.145,0,1,0,0,.289h2.988a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7628.002 11070.47)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4217",
    "data-name": "Path 4217",
    d: "M110.7,159.834a.145.145,0,1,0,0,.289h3.047a.145.145,0,0,0,0-.289Z",
    transform: "translate(-7623.309 11070.47)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4218",
    "data-name": "Path 4218",
    d: "M114.091,73.172l7.858-12.119-.37-.286-7.631,11.769ZM111.57,76.2l-.93,1.435.539.027.606-.933Zm3.337.129,9.074-13.978-.472-.3-8.817,13.583Zm-6.528,5.647q.412-.633.822-1.265l-.552-.007-.767,1.183Zm2.776.129.877-1.351-.652-.021-.853,1.314Zm-10.218,11.35.774-1.194-.558,0-.539.831Zm1.685,1.794,1.986-3.059-.659-.01c-.573.88-1.141,1.756-1.7,2.618Zm-2.5,2.83L88.978,115.243c-.28-.177-1.25-.8-1.531-.977.092-.141,5.055-7.8,11.286-17.373l-.273-.436L86.8,114.406l2.406,1.512,11.3-17.4Zm26.336-39.725,1.068-1.629-2.308-1.571L124.142,56.8l.352.313.852-1.3,1.538,1.046-.829,1.259Z",
    transform: "translate(-7613.597 11110.95)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    "data-name": "Path 4219",
    d: "M139.891,52.591l-2.72,4.156,14.2,9.28.863-1.328-1.6-5.437-10.6-6.883Zm.288.5c.406.262,9.863,6.4,10.016,6.5.051.173,1.415,4.81,1.478,5.027-.079.118-.264.395-.408.612l-13.342-8.721,2.256-3.419",
    transform: "translate(-7632.688 11112.085)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    "data-name": "Path 4220",
    d: "M120.6,99.913l7.564-7.5H109.481l.232.608h16.967l-6.761,6.7m-8.552,8.477-4.054,4.019.38.481,4.377-4.34ZM80.96,99.256c-3.4-3.38-5.96-5.926-6.268-6.233h16.2L91,92.415H73.215l7.079,7.038Zm8.054,8.867,11.633,11.567,6.069-6.018-.326-.535-5.742,5.695L89.827,108.072Zm17.408-15.708H94.787l-.234.608h11.895Z",
    transform: "translate(-7608.042 11096.883)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    d: "M122.446,101.168l3.041-3.028h-8.939l.145.609h7.319l-2.3,2.287Zm-9.762,8.861c-.448.444-.884.878-1.3,1.3l.325.536,1.762-1.755Zm-21.021-9.395-1.877-1.885h6.372l.16-.609h-8l2.606,2.619Zm8.428,9.327,6.731,6.762,3.885-3.869-.329-.533-3.554,3.539-5.935-5.96ZM113.579,98.14H102.632l.369.609h10.713Zm-12.929,0h-.965l-.16.609h1.558Z",
    transform: "translate(-7614.219 11094.508)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    "data-name": "Path 4222",
    d: "M100.046,77.231l1.076-3.249a2.7,2.7,0,0,1,1.068-1.434A4.3,4.3,0,0,1,103.627,72l2.4-6.882-.336-.766c-1.17,3.361-2.459,7.061-2.5,7.185l-.231.07a2.934,2.934,0,0,0-1.029.466,3.447,3.447,0,0,0-1.315,1.721l-.98,2.975Zm-.936,1.133c-.306.924-.638,1.934-.98,2.971l.57-.037.792-2.393ZM94.6,92.047c-2.528,7.674-5.176,15.707-6.447,19.563l.964-1.366L95.184,91.92Zm2.875-18.52c2.555-9.813,5.16-19.823,5.186-19.921l-.365-.472L97.123,73Zm-.8,1.2-1.807,6.938.5-.05c.523-2.007,1.086-4.171,1.66-6.376Zm-4.61,17.7L86.47,113.891l1.285.466.1-.3-.807-.472c.043-.169,2.548-9.791,5.538-21.281Z",
    transform: "translate(-7613.462 11111.777)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4223",
    "data-name": "Path 4223",
    d: "M124.964,81.242l-2.55-7.944.009.047a2.677,2.677,0,0,0-1.285-1.417,6.693,6.693,0,0,0-1.99-.536c-.075-.291-4.38-17.126-4.537-17.74l-.574-.317,4.723,18.478.154.026a7.533,7.533,0,0,1,1.988.5l.016.01.019.008a2.442,2.442,0,0,1,1.009,1.037l0,.022.007.025,2.5,7.791Zm2.94,10.732,5.932,18.477.876,1.155-6.25-19.47Zm.008-10.34L120.3,52.621l-.377.458c.024.095,4.428,16.876,7.473,28.476Zm2.321,10.74c2.894,11.029,5.281,20.12,5.327,20.3-.177.044-.3.076-.468.116l-.408.3.088.274,1.377-.345L130.774,92.54Zm-9.094-20.446.021.009-.035-.018a.046.046,0,0,1,.014.008",
    transform: "translate(-7623.582 11111.987)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4224",
    "data-name": "Path 4224",
    d: "M109.872,96.358c7.542,11.182,14.285,21.175,14.4,21.342-.189.129-.424.293-.617.427-.116-.174-7.061-10.444-14.744-21.81l-.615.006,15.247,22.562,1.413-.985-14.52-21.543ZM89.453,65.228l-1.519.97,13.434,19.883h.619c-.28-.413-13.365-19.772-13.462-19.914.207-.134.484-.311.684-.44l13.7,20.312.547-.031Z",
    transform: "translate(-7614.061 11107.805)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4225",
    "data-name": "Path 4225",
    d: "M79.594,62.447l1.388,1.994,1.773-1.171-1.388-1.993Zm1.818-.658c.188.269.6.93.781,1.186-.245.164-.9.594-1.133.752l-.81-1.157,1.162-.782",
    transform: "translate(-7610.651 11108.448)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4226",
    "data-name": "Path 4226",
    d: "M79.91,56.693,84,62.785,87.149,60.6,83.061,54.5Zm3.028-1.533c.237.354,3.279,4.886,3.51,5.228-.3.211-2.073,1.441-2.386,1.656-.216-.323-3.195-4.74-3.513-5.225l2.389-1.659",
    transform: "translate(-7610.78 11111.216)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4227",
    "data-name": "Path 4227",
    d: "M111.419,45.647v0a4.437,4.437,0,0,0,4.434,4.416,4.357,4.357,0,0,0,4.385-4.388,4.41,4.41,0,0,0-8.819-.031m4.39-3.92a3.942,3.942,0,0,1,3.919,3.921,3.892,3.892,0,0,1-3.92,3.921,3.848,3.848,0,0,1-2.747-1.12,3.922,3.922,0,0,1,2.748-6.721",
    transform: "translate(-7623.663 11116.632)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4228",
    "data-name": "Path 4228",
    d: "M115.583,47.351v0a1.945,1.945,0,0,0,.587,1.4,1.973,1.973,0,0,0,1.38.569,1.853,1.853,0,0,0,1.346-.534,1.921,1.921,0,0,0,.573-1.394,2.015,2.015,0,0,0-1.955-1.965,1.966,1.966,0,0,0-1.931,1.925m1.931-1.458a1.48,1.48,0,0,1,1.454,1.458,1.461,1.461,0,0,1-.434,1.06,1.507,1.507,0,0,1-2.039.005,1.469,1.469,0,0,1,1.019-2.523",
    transform: "translate(-7625.365 11114.929)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4229",
    "data-name": "Path 4229",
    d: "M115.934,48.425c-.085,0-.085.305,0,.305h3.385c.083,0,.083-.305,0-.305Z",
    transform: "translate(-7625.482 11113.702)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4230",
    "data-name": "Path 4230",
    d: "M94.118,81.125a.144.144,0,1,0,0,.288h2.128a.144.144,0,0,0,0-.288Z",
    transform: "translate(-7616.53 11100.96)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4231",
    "data-name": "Path 4231",
    d: "M87.079,81.125a.144.144,0,1,0,0,.288h3.73a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7613.652 11100.96)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4232",
    "data-name": "Path 4232",
    d: "M102.315,82.925a.144.144,0,1,0,0,.288h1.976a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7619.881 11100.252)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4233",
    "data-name": "Path 4233",
    d: "M88.835,85.679a.145.145,0,0,0,0,.289h7.143a.145.145,0,1,0,0-.289Z",
    transform: "translate(-7614.37 11099.169)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4234",
    "data-name": "Path 4234",
    d: "M135.144,141.1a.144.144,0,1,0,0,.288h1.829a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7631.913 11077.384)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4235",
    "data-name": "Path 4235",
    d: "M140.314,81.125a.144.144,0,1,0,0,.288h2.86a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7633.938 11100.96)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4236",
    "data-name": "Path 4236",
    d: "M137.014,100.238a.144.144,0,1,0,0,.288h3.371a.144.144,0,0,0,0-.288Z",
    transform: "translate(-7632.64 11093.447)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4237",
    "data-name": "Path 4237",
    d: "M95.308,100.238a.144.144,0,0,0,0,.288h3.371a.144.144,0,1,0,0-.288Z",
    transform: "translate(-7617.017 11093.447)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4238",
    "data-name": "Path 4238",
    d: "M132.178,82.925a.144.144,0,1,0,0,.288h.9a.144.144,0,0,0,0-.288Z",
    transform: "translate(-7630.752 11100.252)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4239",
    "data-name": "Path 4239",
    d: "M73.326,118.048l2.385.054,1.267-1.588.227.16L75.686,118.6l-2.517-.06Z",
    transform: "translate(-7608.024 11087.073)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4240",
    "data-name": "Path 4240",
    d: "M71.951,117.85l1.292-5.922,5.009,3.115.706.083-1.84.8.194-.419-3.837-2.457-1.033,4.642.275.213-1.127.549Z",
    transform: "translate(-7607.379 11088.937)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4241",
    "data-name": "Path 4241",
    d: "M80.915,108.371l1.9-.558-.078.365,3.668,3.05,1.283-4.246-.213-.225,1.355-.351-.68.5-1.692,5.462-4.708-3.954Z",
    transform: "translate(-7611.191 11091.092)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4242",
    "data-name": "Path 4242",
    d: "M111.424,104.652h.769l5.032,3.817V104.85l-.387-.194,1.172,0-.385.194-.012,5.107-5.18-4.081v3.756l.323.176h-1.1l.38-.176v-4.581Z",
    transform: "translate(-7623.665 11091.771)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4243",
    "data-name": "Path 4243",
    d: "M98.049,111.975l2.328.623,1.659-1.127.161.226-1.992,1.4-2.372-.7Z",
    transform: "translate(-7618.107 11089.048)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4244",
    "data-name": "Path 4244",
    d: "M96,110.945l2.943-5.463,3.821,4.466.688.218-1.984.325.283-.333-2.992-3.535-2.272,4.229.163.3-1.1.111Z",
    transform: "translate(-7617.175 11091.453)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4245",
    "data-name": "Path 4245",
    d: "M141.929,106.713l4.992,1.118.339.727-.635-.479-3.352-.744-.407,1.63,2.451.57.466-.247-.29,1-.237-.446-2.47-.555-.568,2.457,3.419.826.862-.135-.688.535-5.072-1.19.525-.26,1-4.367Z",
    transform: "translate(-7634.142 11090.977)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    "data-name": "Path 4246",
    d: "M132.808,109.958a5.906,5.906,0,0,1-2.559.319c-1.339-.375-2.576-1.306-2.411-2.677.128-1.465,1.34-2.353,3.161-2.108a3.67,3.67,0,0,1,2.152.866l.2-.375a8.765,8.765,0,0,0-2.33-.807c-2.077-.295-4.04.371-4.265,2.193-.29,1.841,1.35,3.093,3.462,3.278a5.54,5.54,0,0,0,2.693-.385c.282-.07-.109-.305-.109-.305",
    transform: "translate(-7628.639 11091.597)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4247",
    "data-name": "Path 4247",
    d: "M155.813,110.8l4.675,2.023-5.879,2.745,3.446,1.5.962.02-.82.408-5.231-2.231,6-2.77-3.078-1.309-.972-.1Z",
    transform: "translate(-7638.938 11089.38)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    "data-name": "Path 4248",
    d: "M66.67,125.72c-.076.075.059.484.134.409,5.181-5.116,16.553-8.3,30.2-8.319,16.354.019,27.323,4.708,30.6,9.058.064.085.2-.275.138-.362-3.329-4.424-14.249-9.062-30.734-9.081-13.74.016-25.081,3.111-30.33,8.294",
    transform: "translate(-7605.358 11086.829)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    "data-name": "Path 4249",
    d: "M62.381,108.936c-1.72.956-2.408,1.78-2.55,2.377-.014.062.233-.083.248-.146.122-.509.8-1.155,2.425-2.036,3.8-2.063,13.646-7.554,31.872-7.525,11.886-.019,22.368,2.463,31.979,7.648A6.984,6.984,0,0,1,129,111.26c.033.053.238.1.2.051a7.314,7.314,0,0,0-2.743-2.259c-9.646-5.205-20.164-7.694-32.089-7.677-18.287-.028-28.2,5.452-31.995,7.561",
    transform: "translate(-7602.57 11093.116)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4250",
    "data-name": "Path 4250",
    d: "M66.434,124.572l.162.165c4.979-5.038,16.579-8.217,30.049-8.217,16.926,0,27.139,4.536,31.007,8.863l.088-.2c-3.9-4.362-14.094-8.893-31.095-8.893-13.528,0-25.191,3.205-30.211,8.283",
    transform: "translate(-7605.271 11087.269)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    "data-name": "Path 4251",
    d: "M58.552,118.505c.008.725,1.212,1.285,2.74,1.282s2.738-.559,2.741-1.279c0-.694-1.179-1.244-2.738-1.28-1.558.036-2.735.586-2.743,1.277m.249,0c.005-.466,1.008-.993,2.493-1.027,1.484.034,2.485.559,2.488,1.029,0,.562-1.143,1.034-2.491,1.029s-2.485-.467-2.491-1.031",
    transform: "translate(-7602.048 11086.8)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4252",
    "data-name": "Path 4252",
    d: "M62,118.4a2.179,2.179,0,0,0-1.418.348L60.5,119a.212.212,0,0,0,.066.167,2.234,2.234,0,0,0,1.444.33,2.272,2.272,0,0,0,1.435-.326s.06-.167.068-.186l-.093-.24A2.205,2.205,0,0,0,62,118.4m1.231.515.03.061a.093.093,0,0,0,0,.014,1.99,1.99,0,0,1-1.26.256A2.033,2.033,0,0,1,60.747,119a.383.383,0,0,1,.025-.081A2,2,0,0,1,62,118.65a1.971,1.971,0,0,1,1.231.265",
    transform: "translate(-7602.842 11086.317)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4253",
    "data-name": "Path 4253",
    d: "M123.816,111.445c.141,1.031.569,3.981.579,5.31-.013,1.7-.532,5.325-.537,5.361a.791.791,0,0,0,.248.591,3.585,3.585,0,0,0,2.452.67,3.665,3.665,0,0,0,2.484-.708.924.924,0,0,0,.278-.635c-.04-.412-.293-3.359-.3-5.28.012-2.026.3-5.306.3-5.313a3.4,3.4,0,0,0-1.929-2.891c-9.1-5.563-20.434-8.512-33.842-8.527-14.215.016-26.367,3.293-33.933,8.973a3.288,3.288,0,0,0-1.313,2.685c0,.055.406,4.218.411,5.134,0,1.906-.315,4.805-.368,5.238a.738.738,0,0,0,.275.646,3.673,3.673,0,0,0,2.489.706,3.58,3.58,0,0,0,2.447-.669.783.783,0,0,0,.249-.573c-.007-.055-.526-3.68-.538-5.382a49.534,49.534,0,0,1,.607-4.94c.07-.517-.173-.687-.15-.6a.667.667,0,0,1-.228.815,29.121,29.121,0,0,0-.644,4.714,48.412,48.412,0,0,0,.54,5.41c0,.1-.024.132-.131.241a3.054,3.054,0,0,1-2.125.586,3.419,3.419,0,0,1-2.265-.617.559.559,0,0,1-.186-.352c.044-.223.06-.628.158-1.75.085-.981.187-2.38.189-3.473-.005-.925-.37-5.128-.37-5.16a3.208,3.208,0,0,1,1.143-2.391c7.5-5.631,19.607-8.906,33.74-8.923,13.335.016,24.639,2.971,33.68,8.5a3.161,3.161,0,0,1,1.766,2.6c-.005.057-.409,3.344-.422,5.311,0,1.1.127,2.517.2,3.5.078,1.113.061,1.492.1,1.722a.549.549,0,0,1-.189.365,3.023,3.023,0,0,1-2.132.62,3.352,3.352,0,0,1-2.224-.573.469.469,0,0,1-.157-.338c0-.02.534-3.571.547-5.293a47.961,47.961,0,0,0-.484-4.818Z",
    transform: "translate(-7601.948 11093.864)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4254",
    "data-name": "Path 4254",
    d: "M169.124,118.462h0c0,.721,1.206,1.284,2.741,1.279s2.732-.557,2.739-1.277c-.008-.7-1.185-1.245-2.737-1.28-1.564.035-2.741.585-2.743,1.277m2.743-1.029c1.478.034,2.374.549,2.379,1.02-.005.56-1.037,1.042-2.381,1.038s-2.489-.468-2.492-1.03c0-.469,1-.994,2.494-1.029",
    transform: "translate(-7645.299 11086.815)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4255",
    "data-name": "Path 4255",
    d: "M172.716,118.356a2.206,2.206,0,0,0-1.411.343s-.084.22-.093.24l.07.186a2.261,2.261,0,0,0,1.438.326,2.235,2.235,0,0,0,1.441-.33.243.243,0,0,0,.064-.2,1.576,1.576,0,0,1-.088-.221,2.191,2.191,0,0,0-1.422-.347m-1.259.577.03-.062a1.973,1.973,0,0,1,1.23-.266,2.011,2.011,0,0,1,1.236.265l.027.058c0,.017,0,.02,0,.02a3.249,3.249,0,0,1-2.522,0Z",
    transform: "translate(-7646.139 11086.334)",
    fill: "#00acff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    "data-name": "Path 4256",
    d: "M235.559,95.288a10.337,10.337,0,0,1-5.789,1.769c-5.219,0-7.979-3.089-7.979-9.509,0-4.92,2.76-9.389,8.369-9.389a8.248,8.248,0,0,1,5.55,1.77L234.149,82a5.081,5.081,0,0,0-4.049-1.56c-3.72,0-5.64,2.79-5.64,7.019,0,4.92,1.98,7.319,5.609,7.319a7.93,7.93,0,0,0,4.289-1.409Z",
    transform: "translate(-7665.888 11102.282)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4257",
    "data-name": "Path 4257",
    d: "M263.266,78.616V96.975h-2.58v-8.4l-8.429.3v8.1h-2.579V78.616h2.579v8.04l8.429-.36v-7.68Z",
    transform: "translate(-7676.833 11102.1)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4258",
    "data-name": "Path 4258",
    d: "M285.407,78.464l6.18,18.449h-2.76l-1.739-5.4-6.781.39-1.649,5.009h-2.61l6.6-18.329Zm-4.349,11.159,5.34-.27-.42-1.35-2.13-6.84-2.249,6.87Z",
    transform: "translate(-7687.146 11102.159)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4259",
    "data-name": "Path 4259",
    d: "M305.469,78.616h2.58V94.695h7.828v2.28H305.469Z",
    transform: "translate(-7698.774 11102.1)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4260",
    "data-name": "Path 4260",
    d: "M342.4,86.443l.09-3.45-1.289,3.54-4.169,10.379-2.16.209-4.381-10.469L329.23,83.2l.09,3.45V96.912h-2.46V78.583l2.759-.12,5.31,12.57,1.051,2.939,1.019-3,5.16-12.509,2.7.12V96.912H342.4Z",
    transform: "translate(-7707.023 11102.163)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    "data-name": "Path 4261",
    d: "M372.633,78.616v2.25h-8.19v5.669l6.811-.3v2.249l-6.811.271v5.939h8.67v2.28h-11.25V78.616Z",
    transform: "translate(-7720.892 11102.1)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    "data-name": "Path 4262",
    d: "M384.84,78.764a48.414,48.414,0,0,1,5.22-.3c4.439,0,6.089,2.43,6.149,5.609a5.38,5.38,0,0,1-3.271,5.1l4.321,7.739-2.82.24-3.869-7.139a26.572,26.572,0,0,1-3.18.57v6.329h-2.55Zm4.769,1.95a21.562,21.562,0,0,0-2.219.12v7.409c4.049-.21,6.149-1.35,6.149-3.9,0-2.279-1.259-3.63-3.93-3.63",
    transform: "translate(-7729.882 11102.162)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    "data-name": "Path 4263",
    d: "M416.168,92.138c0-1.74-1.921-2.82-3.691-3.9-2.1-1.319-4.2-2.61-4.2-5.19,0-2.969,2.161-4.889,5.339-4.889a7.878,7.878,0,0,1,4.98,1.47l-1.47,2.01a4.586,4.586,0,0,0-3.421-1.26c-1.709,0-2.79.87-2.79,2.31,0,1.47,1.531,2.43,3.09,3.42,2.28,1.38,4.831,2.759,4.831,5.849,0,3.3-2.881,5.1-6.15,5.1a8.121,8.121,0,0,1-5.04-1.47L409,93.548a5.648,5.648,0,0,0,3.811,1.291c1.77,0,3.361-1.081,3.361-2.7",
    transform: "translate(-7738.091 11102.283)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    "data-name": "Path 4264",
    d: "M227.333,131.769c0-1.74-1.921-2.82-3.689-3.9-2.1-1.32-4.2-2.61-4.2-5.189,0-2.97,2.16-4.89,5.339-4.89a7.874,7.874,0,0,1,4.98,1.47l-1.47,2.009a4.583,4.583,0,0,0-3.42-1.26c-1.71,0-2.79.87-2.79,2.31,0,1.47,1.53,2.43,3.09,3.419,2.28,1.379,4.83,2.759,4.83,5.849,0,3.3-2.88,5.1-6.15,5.1a8.124,8.124,0,0,1-5.04-1.47l1.35-2.039a5.641,5.641,0,0,0,3.809,1.29c1.77,0,3.36-1.08,3.36-2.7",
    transform: "translate(-7664.753 11086.872)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4265",
    "data-name": "Path 4265",
    d: "M240.029,118.246h13.236V120.5h-5.313v16.109h-2.58V120.5h-5.343Z",
    transform: "translate(-7673.053 11086.684)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4266",
    "data-name": "Path 4266",
    d: "M277.614,118.246H280.1v12.33c0,5.1-4.2,6.3-7.08,6.3-2.639,0-6.779-.9-6.779-6.06V118.246h2.55v11.728c0,4.021,1.889,4.62,4.47,4.62,2.639,0,4.35-1.11,4.35-4.8Z",
    transform: "translate(-7683.327 11086.689)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4267",
    "data-name": "Path 4267",
    d: "M294.213,118.346c1.77-.06,3.479-.15,5.31-.15,6.57,0,9.24,3.3,9.24,8.759s-2.1,9.629-9.21,9.629h-5.34Zm2.58,2.219V134.3h2.88c4.95,0,6.419-2.79,6.419-6.99,0-5.249-2.429-6.869-6.84-6.869-.87,0-1.62.06-2.459.119",
    transform: "translate(-7694.287 11086.703)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4268",
    "data-name": "Path 4268",
    d: "M332.93,118.246V120.5h-8.189v5.67l6.809-.3v2.249l-6.809.27v5.94h8.669v2.28H322.16V118.246Z",
    transform: "translate(-7705.311 11086.684)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4269",
    "data-name": "Path 4269",
    d: "M347.629,136.543h-2.491V118.214l2.521-.12,7.559,11.369,1.889,3.27-.119-3.42V118.184h2.489v18.329l-2.43.18-7.558-11.339-2.04-3.36.18,3.449Z",
    transform: "translate(-7714.265 11086.748)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4270",
    "data-name": "Path 4270",
    d: "M373.576,118.246h13.43V120.5H381.6v16.109h-2.579V120.5h-5.44Z",
    transform: "translate(-7725.44 11086.684)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4271",
    "data-name": "Path 4271",
    d: "M403.032,136.6h-2.579V118.246h2.579Zm2.889-9.419,6.722,9.419-2.851.3-6.69-9.39,6.36-9.269h2.88Z",
    transform: "translate(-7735.149 11086.689)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4272",
    "data-name": "Path 4272",
    d: "M432.541,113.965l6.179,18.449h-2.76l-1.739-5.4-6.776.39-1.649,5.01h-2.612l6.6-18.329Zm-4.347,11.159,5.337-.27-.42-1.35-2.129-6.839-2.247,6.869Zm.24-14.46a2.658,2.658,0,0,1,2.756-2.67,2.536,2.536,0,0,1,2.671,2.67,2.7,2.7,0,0,1-2.73,2.7,2.614,2.614,0,0,1-2.7-2.7m4.138,0a1.458,1.458,0,1,0-2.909,0,1.42,1.42,0,0,0,1.468,1.59c.9,0,1.441-.569,1.441-1.59",
    transform: "translate(-7744.443 11090.798)",
    fill: "#222d34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4273",
    "data-name": "Path 4273",
    d: "M452.578,118.395a48.564,48.564,0,0,1,5.219-.3c4.44,0,6.089,2.429,6.15,5.609a5.38,5.38,0,0,1-3.268,5.1l4.318,7.74-2.819.241-3.869-7.14a26.463,26.463,0,0,1-3.18.57v6.329h-2.55Zm4.77,1.95a21.752,21.752,0,0,0-2.22.12v7.41c4.049-.21,6.149-1.35,6.149-3.9,0-2.281-1.259-3.631-3.929-3.631",
    transform: "translate(-7756.46 11086.749)",
    fill: "#222d34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalmersLogo);
export default __webpack_public_path__ + "static/media/chalmersLogo.b4f9f9a3de0bbe5b3b93cdd44feb52b6.svg";
export { ForwardRef as ReactComponent };